import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

function Zipcode() {
  const dispatch = useDispatch();
  const {
    doctors: { selectedZip },
  } = useSelector(store => store);

  function handleChange(event) {
    const { value } = event.target;
    dispatch({ type: 'SET_DOCTORS_ZIPCODE', payload: value });
  }

  return (
    <>
      Zipcode
      <input
        type="text"
        id="doctor-zip-input"
        className="form-control me-3"
        value={selectedZip}
        onChange={handleChange}
        disabled
      />
    </>
  );
}

export default Zipcode;
